<script setup>
import { useCartStore } from '../stores/cartStore'
import { defineProps } from 'vue'

const cartStore = useCartStore()

const props = defineProps({
  company: Object
})

function reloadCart(companyUuid) {
  cartStore.reloadCartData({
    slug: cartStore.cartData.slug,
    companyUuid: companyUuid
  })
  cartStore.goToStep(0)
}
</script>
<template>
  <div class="card mb-3">
    <div class="card-body">
      <div class="row">
        <div class="col-md-8 mb-xs-3 mb-md-0">
          <h5 class="card-title">
            {{ company.corporationName }}
          </h5>
          <p class="mb-0">
            <small class="text-muted"
              >Document Number: {{ company.documentNumber }}</small
            >
          </p>
          <p>
            <span
              class="badge"
              :class="{
                'bg-soft-danger text-danger': company.status === 'I',
                'bg-soft-success text-success': company.status === 'A'
              }"
            >
              {{
                cartStore.getChoiceDisplay(
                  'florida_corporation_status',
                  company.status
                )
              }}</span
            >
            <span class="badge bg-soft-danger text-danger ms-1"
              >1 Filing Due</span
            >
          </p>
        </div>

        <div
          class="col-md-4 d-md-flex align-items-center justify-content-md-end d-grid"
        >
          <a
            @click="reloadCart(company.companyUuid)"
            class="btn btn-small btn-primary"
            >File Now <i class="fa-light fa-chevron-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
